<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template >
  <footer v-if="this.verticalNavMenuWidth === 'default'" class="the-footer flex-wrap justify-between" :class="classes">
    <!-- 서버 설정(footer.replace)이 있으면 기본 문구 대신 표시한다 -->
    <p v-if="footerReplace" class="footer-text">{{ footerReplace }}</p>
    <p v-else style="display: flex; align-items: center;">
      <span>COPYRIGHT &copy;</span>
      <span>{{ new Date().getFullYear() }} </span>
      <a href="/" target="_blank" rel="nofollow">&nbsp;Digital SHM System</a>
      <span class="hidden sm:inline-block">, All rights Reserved. T.070-7007-7979</span>
    </p>
    <!-- 서버 설정(footer.append)이 있으면 오른쪽에 덧붙인다 (예: 제품명·버전) -->
    <span v-if="footerAppend" class="footer-text">{{ footerAppend }}</span>
    <span v-else class="md:flex hidden items-center">
          <!--
            푸터 오른쪽 문구 사용하지 않음
            <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
          -->
        </span>
  </footer>
  <footer v-else class="the-footer flex-wrap justify-between" :class="classes">
    <p v-if="footerReplace" class="footer-text">{{ footerReplace }}</p>
    <p v-else style="display: grid; align-items: center;">
      <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} <a href="/" target="_blank" rel="nofollow">&nbsp;Digital SHM System, </a></span>
      <span>All rights Reserved</span>
    </p>
    <p v-if="footerAppend" class="footer-text w-full">{{ footerAppend }}</p>
  </footer>
</template>

<script>
/**
 * 푸터 문구는 서버 설정(MaotConfig key = 'footer', is_public = 1)으로 바꿀 수 있다.
 *   {"append": "마엇 이지스 엑스-1.0"}   기본 문구는 그대로 두고 덧붙인다 (PC: 오른쪽, 모바일: 아래 줄)
 *   {"replace": "..."}                  기본 문구 대신 표시한다
 * 설정이 없으면 기본 문구만 표시한다. 줄바꿈(\n)은 그대로 표시된다.
 */
const FOOTER_CONFIG_KEY = 'footer'

export default {
  name: 'the-footer',

  props: {
    classes: {
      type: String
    }
  },

  data() {
    return {
      footerConfig: null,
    }
  },

  async created() {
    try {
      // 설정이 없는 서버가 대부분이라 404 가 정상이다. 오류 알림을 띄우지 않는다
      const config = await this.$store.dispatch('keyValue/LOAD_CONFIG', { key: FOOTER_CONFIG_KEY, notWarn: true })
      this.footerConfig = config && typeof config === 'object' ? config : null
    } catch (e) {
      this.footerConfig = null
    }
  },

  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    footerAppend() {
      const value = this.footerConfig && this.footerConfig.append
      return typeof value === 'string' && value.trim() ? value : ''
    },
    footerReplace() {
      const value = this.footerConfig && this.footerConfig.replace
      return typeof value === 'string' && value.trim() ? value : ''
    },
  },
}
</script>

<style scoped>
.footer-text {
  white-space: pre-line;
}
</style>
